import * as React from 'react';

import {CheckboxForGroup} from 'shells/checkbox/checkbox-for-group';
import {CheckboxGroup} from 'shells/checkbox/checkbox-group';

type Props = {
    value?: any;
    name: string;
    onChange: (...args: any) => any;
    nullOptionText?: string;
    enum: any;
};

export class FormBadge extends React.Component<Props> {
    render() {
        return (
            <CheckboxGroup
                name='checkbox-story'
                onChange={(newVal) => {
                    this.props.onChange({
                        [this.props.name]: {
                            anyAll: 'any',
                            data: newVal
                                ? newVal.map((value) => {
                                      return {
                                          data: value,
                                      };
                                  })
                                : [],
                        },
                    });
                }}
                selectedValues={
                    this.props.value && this.props.value.data
                        ? // @ts-expect-error
                          this.props.value.data.map((value) => {
                              return value.data;
                          })
                        : []
                }
            >
                {Object.keys(this.props.enum).map((option) => {
                    return (
                        <CheckboxForGroup key={option} value={option} isLarge={false}>
                            {option}
                        </CheckboxForGroup>
                    );
                })}
                {this.props.nullOptionText ? (
                    <CheckboxForGroup value='-' isLarge={false}>
                        {this.props.nullOptionText}
                    </CheckboxForGroup>
                ) : undefined}
            </CheckboxGroup>
        );
    }
}
